module.exports = {
  API_URL: 'https://dee0nbarqh.execute-api.eu-central-1.amazonaws.com/prod/',
};
